import React from 'react';
import PlanDetailSection from '../../../sections/AdminDashboard/Configuration/PlanDetail';

const PlanDetail = () => {
  return <PlanDetailSection />;
};

export default PlanDetail;
